import { render, staticRenderFns } from "./StarredChannels.html?vue&type=template&id=1bbe6f1c&scoped=true&"
import script from "./StarredChannels.js?vue&type=script&lang=js&"
export * from "./StarredChannels.js?vue&type=script&lang=js&"
import style0 from "./StarredChannels.scss?vue&type=style&index=0&id=1bbe6f1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbe6f1c",
  null
  
)

export default component.exports